import { MapGroupId } from "../../types";
import img from "../../mapImages/LighthouseMain2D.webp";

const mapData = {
  groupId: MapGroupId.Lighthouse,
  groupName: {
    en: "Lighthouse",
    ru: "Маяк",
  },
  title: {
    en: "Main 2D",
    ru: "Главная 2D",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
